import { Link, NavLink } from 'react-router-dom';
import clsx from 'clsx';
import {
  HomeIcon,
  ChatIcon,
  AdjustmentsIcon,
  CalendarIcon,
} from '@heroicons/react/outline';
import { LISTURL, TITLE } from '../config';
import { defaultAuth } from '../atoms/auth';

const Tab = (): JSX.Element => {
  return (
    <div className="fixed bottom-0 left-0 w-full h-[60px] flex lg:hidden bg-white">
      <div className="flex-1 flex flex-col items-center h-full p-2">
        <Link
          to={LISTURL.general}
          className="w-full h-[32px] flex justify-center items-center px-2"
        >
          <img
            src="https://assets.onistudio.net/review-land-official.png"
            alt={TITLE}
            className="w-full h-full object-contain"
          />
        </Link>
        <span className="text-xs text-gray-500">
          {defaultAuth?.myharavan_domain
            .replace('https://', '')
            .replace('http://', '')}
        </span>
      </div>
      <ul className="flex flex-1 space-x-2 justify-between items-center">
        <li className="block">
          <NavLink
            to={LISTURL.general}
            className={({ isActive }) =>
              clsx(
                'w-full flex items-center p-2 text-gray-600',
                isActive ? 'text-indigo-600' : undefined,
              )
            }
          >
            <HomeIcon className="w-6 h-6" />
          </NavLink>
        </li>
        <li className="block">
          <NavLink
            to={LISTURL.reviews_list}
            className={({ isActive }) =>
              clsx(
                'w-full flex items-center p-2 text-gray-600',
                isActive ? 'text-indigo-600' : undefined,
              )
            }
          >
            <ChatIcon className="w-6 h-6" />
          </NavLink>
        </li>
        <li className="block">
          <NavLink
            to={LISTURL.question_list}
            className={({ isActive }) =>
              clsx(
                'w-full flex items-center p-2 text-gray-600',
                isActive ? 'text-indigo-600' : undefined,
              )
            }
          >
            <CalendarIcon className="w-6 h-6" />
          </NavLink>
        </li>
        <li className="block">
          <NavLink
            to={LISTURL.settings}
            className={({ isActive }) =>
              clsx(
                'w-full flex items-center p-2 text-gray-600',
                isActive ? 'text-indigo-600' : undefined,
              )
            }
          >
            <AdjustmentsIcon className="w-6 h-6" />
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Tab;
